module.exports = __webpack_public_path__ + "img/emo_60.ec9a7a5c.png";